export const resources = {
  ShowMore: '',
  KeywordRemoveTitle: ''
};
